module.exports = __webpack_public_path__ + "static/media/minesweeper.493f8ef5.md";